module.exports = __webpack_public_path__ + "img/company-team-1.82ded295.jpg";